import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Calendar, ChevronDown, ChevronLeft, Share } from "lucide-react";
// import { format } from "date-fns";
import { TailSpin } from "react-loader-spinner";
import { DDGColors } from "../../constants/colors";
import { AppState } from "../../state";
import {
  convertDateToString,
  formatCurrency,
  formatDateToDisplayString,
  formatNumberScale,
  getInitials,
} from "../../functions";
import BookingSteps from "../../components/BookingSteps";
import { useSwitchPage } from "../../state/features/applicationSlice/hooks";
import {
  ApplicationPages,
  setActiveClassBooking,
} from "../../state/features/applicationSlice";
import Image from "../../components/Image";
import AppointmentSelector from "../../components/BookingSteps/WellnessClassCalendarView";
import DateSelectorSheet from "../../components/DateSelectorSheet";
import { shareOnMobile } from "react-mobile-share";
import useCopy from "../../config/useCopy";
interface startProps {}
const BookClassStart: React.FC<startProps> = ({}) => {
  const { activeClass: wellnessClass, activeFacility: hospital } = useSelector<
    AppState,
    AppState["application"]
  >((state) => state.application);
  const [selectedSession, setSelectedSession] = useState<any>(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const dispatch = useDispatch();
  const { handleCopy } = useCopy();
  const router = useSwitchPage();
  if (!hospital || !wellnessClass) {
    return (
      <div
        style={{ minHeight: 500 }}
        className="relative flex items-center justify-center flex-col flex-grow w-full h-full max-w-lg mx-auto overflow-y-hidden min-h-[300px]"
      >
        <TailSpin width="20" color={DDGColors.primary} />
      </div>
    );
  }

  console.log(
    "wellnessClass?.bookingDiscount",
    wellnessClass?.bookingDiscount?.message
  );
  return (
    <main className="flex flex-col h-full overflow-y-scroll ">
      {/* Header Image */}
      <div className="relative h-64">
        {/* Navigation buttons */}
        <div className="absolute z-10 flex flex-row items-center justify-between w-full px-4 top-4">
          <button
            onClick={() => {
              router(ApplicationPages.HOME);
            }}
            className="flex items-center justify-center w-8 h-8 bg-opacity-50 rounded-full bg-slate-700"
          >
            <ChevronLeft size={20} color="white" />
          </button>
          <button
            onClick={() => {
              shareOnMobile(
                {
                  text: `I just found my new wellness sanctuary at ${hospital.details.institutionName}. Rejuvenate your mind and body—you deserve this! Check it out`,
                  url: window.location.href,
                  title: `${hospital.details.institutionName} - DrDoGood`,
                },
                (message) => {
                  console.log("message sharing", message);
                  handleCopy(window.location.href);
                }
              );
            }}
            className="flex items-center justify-center w-8 h-8 bg-opacity-50 rounded-full bg-slate-700"
          >
            <Share size={20} color="white" />
          </button>
        </div>

        {/* Background image */}
        <div className="relative h-64 bg-gray-800">
          <div className="absolute w-full h-full bg-black/20"></div>
          <Image
            className="object-cover w-full h-full "
            src={wellnessClass?.image ?? ""}
            alt={wellnessClass?.title ?? ""}
            useBase={false}
          />
        </div>

        {/* Logo and title */}
        <div className="absolute left-0 flex items-center w-full px-4 bottom-8">
          <div className="mr-4">
            <div className="flex items-center justify-center w-12 h-12 overflow-hidden bg-white border-2 border-white rounded-full">
              <div className="text-xs font-bold text-center text-red-500">
                <Image
                  useBase={false}
                  className="flex-1 w-full h-full bg-white border rounded-full p-dark border-primaryLight"
                  src={hospital.details.logoImage ?? ""}
                  alt={hospital.details.institutionName}
                />
              </div>
            </div>
          </div>
          <div>
            <h1 className="text-xl font-bold text-white">
              {wellnessClass?.title ?? ""}
            </h1>
            <div className="text-sm text-white/80">
              {hospital.details.address.city},{" "}
              {hospital.details.address.country}
            </div>
          </div>
        </div>

        {/* Carousel indicators */}
        {/* <div className="absolute left-0 flex justify-center w-full gap-2 bottom-2">
          <div className="w-2 h-2 bg-teal-400 rounded-full"></div>
          <div className="w-2 h-2 rounded-full bg-white/50"></div>
          <div className="w-2 h-2 rounded-full bg-white/50"></div>
          <div className="w-2 h-2 rounded-full bg-white/50"></div>
        </div> */}
      </div>

      {/* Promotion Banner */}

      {wellnessClass?.bookingDiscount?.message &&
        wellnessClass?.bookingDiscount?.percentage > 0 && (
          <div className="py-3 text-xs font-semibold text-center text-white bg-primary">
            {wellnessClass?.bookingDiscount.message}
          </div>
        )}

      {/* Content */}
      <div className="pb-24 overflow-y-scroll ">
        {/* Tab Navigation */}
        <div className="flex flex-row items-start p-4">
          <div className="flex-1 text-sm font-bold">
            <p>{wellnessClass?.title}</p>
            <p className="text-[11px] text-gray-500">
              By {wellnessClass.facility_details.name}
            </p>
          </div>
          <div className="flex items-center px-4 text-xs text-gray-500">
            {wellnessClass.isFree ? 'FREE': formatCurrency(wellnessClass?.price)}
          </div>
        </div>
        {/* About Section */}
        <div className="px-4 pb-4 text-xs text-justify text-[#3A3A3A]">
          <p>{wellnessClass?.description ?? ""}</p>
        </div>
        <div className="flex items-center px-4 pb-4 ">
          <div className="px-3 py-1.5  text-[11px] font-bold text-primary bg-primaryLight rounded-lg">
            {wellnessClass.category ?? ""}
          </div>
        </div>

        {/* Instructors and Capacity */}
        <div className="flex border-[#EEEEEE] border-y">
          <div className="flex-1 p-4">
            <h2 className="mb-2 text-xs font-bold">Instructor</h2>
            {wellnessClass.instructor ? (
              <div className="flex flex-row items-center space-x-2">
                <div className="relative self-start w-6 h-6 ">
                  <Image
                    className="object-cover w-full h-full rounded-full"
                    src={
                      [...(hospital?.classInstructors ?? [])].find(
                        (instructor) =>
                          instructor.id === wellnessClass.instructor
                      )?.image ?? ""
                    }
                    alt="--"
                    useBase={false}
                  />
                </div>
                <p className="text-xs text-[#3A3A3A]">
                  {wellnessClass?.instructor
                    ? [...(hospital?.classInstructors ?? [])].find(
                        (instructor) =>
                          instructor.id === wellnessClass.instructor
                      )?.name
                    : "--"}
                </p>
              </div>
            ) : (
              <p>--</p>
            )}
          </div>
          <div className="flex-1 p-4">
            <h2 className="mb-2 text-xs font-bold">Capacity</h2>
            <p className="text-xs text-[#3A3A3A]">
              {wellnessClass?.capacity ?? 10} Participants
            </p>
          </div>
        </div>

        {/* Class Hours */}
        <div className="p-4">
          <h2 className="mb-4 text-xs font-bold">Class Hours</h2>
          <p className="pb-3 text-xs text-gray-500 ">Select a class date</p>
          {wellnessClass.classHours.map((classHour) => {
            return (
              <div
                key={classHour.id}
                className="flex flex-row items-center justify-between text-sm"
              >
                <p className="text-sm text-gray-500 capitalize">
                  {classHour.day}
                  <span className="lowercase">s</span>:{" "}
                </p>
                <p className="text-sm">
                  {classHour.interval.from} - {classHour.interval.to}
                </p>
              </div>
            );
          })}
        </div>
        <div className="border-t border-gray-200"></div>
      </div>

      <div className="fixed bottom-0 w-full p-4 bg-white">
        {/* Date Picker */}
        <div className="">
          <button
            onClick={() => setIsDatePickerOpen(true)}
            className="flex items-center justify-between w-full text-xl font-bold"
          >
            <div className="flex items-center text-xs font-semibold">
              <Calendar className="mr-2 text-[#292D32]" size={16} />
              <p>
                {selectedSession
                  ? formatDateToDisplayString(selectedSession.timeDate)
                  : "Select a Class Date"}
              </p>
            </div>
            {selectedSession ? (
              <p className="text-xs font-semibold text-primary">
                Change schedule
              </p>
            ) : (
              <ChevronDown />
            )}
          </button>
        </div>

        {/* Date Selector Sheet */}
        {wellnessClass && (
          <DateSelectorSheet
            activeFacility={hospital}
            wellnessClass={wellnessClass}
            isOpen={isDatePickerOpen}
            onClose={() => setIsDatePickerOpen(false)}
            onSelectSession={(session) => {
              setSelectedSession(session);
              setIsDatePickerOpen(false);
            }}
          />
        )}

        <button
          onClick={() => {
            if (selectedSession) {
              dispatch(
                setActiveClassBooking({
                  classHourId: selectedSession.classHourId,
                  date: selectedSession.timeDate,
                })
              );
              router(ApplicationPages.BOOKING_CLASS_STEP_TWO);
            } else {
				console.log('okay')
              setIsDatePickerOpen(true);
            }
          }}
          className={`w-full py-3 mt-4 text-sm font-semibold rounded-lg  ${
            selectedSession
              ? "text-white bg-primary"
              : "text-primary bg-primary/30"
          }`}
        >
          Book Now
        </button>
      </div>
    </main>
  );
};
export default BookClassStart;
